import React from "react";
import ICustomButton from "models/CustomButton";
import { Button, Typography } from "@mui/material";

const CustomButton: React.FC<ICustomButton> = ({ startIcon, title, onClick, ...props }) => {
  return (
    <Button
      variant="contained"
      startIcon={startIcon}
      onClick={onClick}
      sx={{
        px: "12px",
        py: "4px",
        backgroundColor: "#146ED2",
        alignSelf: "start",
      }}
      {...props}
    >
      <Typography variant="h6" sx={{ fontSize: "15px", textTransform: "none", fontWeight: 800 }}>
        {title}
      </Typography>{" "}
    </Button>
  );
};

export default CustomButton;
